import React from 'react';
import { Lock, CreditCard } from 'lucide-react';
import { trackEvent } from '../hooks/useMetaPixel';
export function Footer() {
  return <footer id="footer" className="bg-[#080808] py-12 px-6 text-center border-t border-white/5" data-id="element-180">
      <img src="https://i.postimg.cc/434FGjc3/LOGO-2.png" alt="Pasta Sin Gluten" className="h-[50px] mx-auto mb-5 opacity-70" data-id="element-181" />

      <div className="flex justify-center gap-7 flex-wrap mb-5" data-id="element-182">
        <a href="#" className="text-[12px] text-white/40 no-underline transition-colors duration-200 hover:text-oro" data-id="element-183">
          Política de Privacidad
        </a>
        <a href="#" className="text-[12px] text-white/40 no-underline transition-colors duration-200 hover:text-oro" data-id="element-184">
          Términos y Condiciones
        </a>
        <a href="#" className="text-[12px] text-white/40 no-underline transition-colors duration-200 hover:text-oro" data-id="element-185">
          Política de Reembolso
        </a>
        <a href="#" className="text-[12px] text-white/40 no-underline transition-colors duration-200 hover:text-oro" data-id="element-186">
          Contacto
        </a>
      </div>

      <div className="flex justify-center items-center gap-3 mb-5 text-white/25" data-id="element-187">
        <CreditCard size={22} data-id="element-188" />
        <CreditCard size={22} data-id="element-189" />
        <CreditCard size={22} data-id="element-190" />
        <CreditCard size={22} data-id="element-191" />
        <Lock size={16} data-id="element-192" />
      </div>

      <p className="text-[11px] text-white/20 leading-[1.7]" data-id="element-193">
        © 2025 Pasta Sin Gluten — Hugo Otero. Todos los derechos reservados.
        <br data-id="element-194" />
        Este ebook es un producto digital. Los resultados pueden variar según la
        aplicación individual del método.
        <br data-id="element-195" />
        <a href="#cta-final" onClick={e => {
        e.preventDefault();
        trackEvent('InitiateCheckout', {
          content_name: 'Footer CTA',
          value: 12,
          currency: 'USD'
        });
        document.getElementById('cta-final')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="text-oro no-underline cursor-pointer" data-id="element-196">
          Procesar compra segura →
        </a>
      </p>
    </footer>;
}